import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import { Calendar } from 'primereact/calendar';
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";

import app from "../../../firebase-config";
import { Chip } from "primereact/chip";
import { getColumnSearchProps } from "../../general/FilterHeaderColumn";
import moment from "moment";
import { Table } from "antd";

function DataBase() {
  const [ultimoEstado, setUltimoEstado] = useState({});
  const [startDate, setStartDate] = useState(new Date());
  const [detalle, setDetalle] = useState("");
  const [message, setMessage] = useState("");
  const [estado, setEstado] = useState("");
  const [errorEstate, setErrorEstate] = useState(false);
  const [errorFecha, setErrorFecha] = useState(false);

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const columns = [{
    title: "Nombres",
    key: "nombres",
    dataIndex: "nombres",
    align: "center",
    fixed: "left",
    width: 150,
    ...getColumnSearchProps(
      "nombres",
      "Nombres",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
  },
  {
    title: "Apellidos",
    key: "apellidos",
    dataIndex: "apellidos",
    align: "center",
    fixed: "left",
    width: 150,
    ...getColumnSearchProps(
      "apellidos",
      "Apellidos",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
  },
  {
    title: "Doc.",
    key: "tipoDoc",
    dataIndex: "tipoDoc",
    align: "center",
    fixed: "left",
    width: 65,
  },
  {
    title: "Nro. Documento",
    key: "nroDoc",
    dataIndex: "nroDoc",
    align: "center",
    fixed: "left",
    width: 125,
    ...getColumnSearchProps(
      "nroDoc",
      "Nro. Documento",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
  },
  {
    title: "Correo",
    key: "email",
    dataIndex: "email",
    align: "center",
    width: 200,
    ...getColumnSearchProps(
      "email",
      "Correo",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
  },
  {
    title: "Empresa",
    key: "empresa",
    dataIndex: "empresa",
    align: "center",
    width: 175,
    ...getColumnSearchProps(
      "empresa",
      "Empresa",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
  },
  {
    title: "Cargo",
    dataIndex: "cargo",
    key: "cargo",
    align: "center",
    width: 175,
    ...getColumnSearchProps(
      "cargo",
      "Cargo",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
    render: (text) => {
      return (text ? text.toUpperCase() : "-");
    },
  },
  {
    title: "Última Conexión",
    dataIndex: "lastConnection",
    key: "lastConnection",
    align: "center",
    width: 175,
    ...getColumnSearchProps(
      "lastConnection",
      "Última Conexión",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
    render: (text) => {
      if (!text) return "-"
      const millis =
        text.seconds * 1000 +
        text.nanoseconds / 1e6;
      const formatted = moment(millis).format("DD/MM/YYYY HH:mm");
      return formatted
    },
  },
  {
    title: "Estado",
    dataIndex: "estado",
    key: "estado",
    width: 85,
    align: "center",
    render: (_, row) => {
      const color = row.estado === "enabled" ? "#2e7d32" : row.estado === "disabled" ? "#c62828" : "#f9a825";
      return (
        <Chip
          style={{
            alignItems: "center",
            padding: 10,
            backgroundColor: color,
            color: "#ffffff",
            fontWeight: "bold",
          }}
        />
      );
    },
  },
  {
    title: "Acciones",
    dataIndex: "acciones",
    key: "acciones",
    width: 100,
    align: "center",
    fixed: "right",
    render: (_, row) => {
      return (
        <button
          style={{ width: "40px" }}
          id={row.idUserAuth}
          onClick={(e) =>
            borrarUsuario(
              row.nombres,
              row.apellidos,
              row.idUserAuth
            )
          }
          className="btn btn-block bg-gradient-secondary btn-sm"
        >
          <i className="far fa-trash-alt"></i>
        </button>
      );
    },
  },
  ];

  function confirmDialog(deta, estad, milisegundos, fecha, msg) {
    Swal.fire({
      title: "Agregar registro:\n" + deta + "\n" + fecha,
      text:
        "La siguiente acción agregará un estado directamente. ¿Esta seguro que desea continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Si, continuar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        spinnerModal();
        app
          .firestore()
          .collection("sensor")
          .add({ detalle: deta, estado: estad, hora: milisegundos.toString(), message: msg })
          .then(() => {
            Swal.fire("Agregado!", "El estado ha cambiado.", "success");
          })
          .catch(() => {
            Swal.fire("Error!", "No se pudo agregar el estado.", "error");
          });

        app
          .firestore()
          .collection("notification")
          .doc("sensor")
          .set({ detalle: deta, estado: estad, hora: milisegundos.toString() });
      }
    });
  }

  function borrarUsuario(nombres, apellidos, id) {
    confirmBorrarUsuarioDialog(nombres, apellidos, id);
  }

  function confirmBorrarUsuarioDialog(nombres, apellidos, id) {
    Swal.fire({
      title: "Eliminar usuario:\n" + nombres + " " + apellidos,
      text:
        "Si confirma, eliminará todos los datos del usuario. ¿Está seguro de continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        spinnerModal();
        const borrarUser = app.functions().httpsCallable("borrarUsuario");

        borrarUser({ idUserAuth: id })
          .then(() => {
            Swal.fire("Eliminado!", "El usuario ha sido eliminado.", "success");
          })
          .catch((e) => {
            console.log(e)
            Swal.fire("Error!", "No se pudo eliminar al usuario.", "error");
          });
      }
    });
  }

  function confirmDialog2(deta, estad, milisegundos, fecha, msg) {
    Swal.fire({
      title: "Agregar registro:\n" + deta + "\n" + fecha,
      text:
        "La siguiente acción eliminara usuarios. ¿Esta seguro que desea continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Si, continuar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        spinnerModal();
        /* app
          .firestore()
          .collection("sensor")
          .add({ detalle: deta, estado: estad, hora: milisegundos.toString(), message: msg })
          .then(() => {
            Swal.fire("Agregado!", "El estado ha cambiado.", "success");
          })
          .catch(() => {
            Swal.fire("Error!", "No se pudo agregar el estado.", "error");
          });

        app
          .firestore()
          .collection("notification")
          .doc("sensor")
          .set({ detalle: deta, estado: estad, hora: milisegundos.toString() }); */
      }
    });
  }

  function spinnerModal() {
    Swal.fire({
      title: "Procesando registro",
      html: "Espere un momento por favor.",
      didOpen: () => {
        Swal.showLoading();
      }
    });
  }

  async function agregarRegistro(event) {
    event.preventDefault();
    if (detalle === "") {
      setErrorEstate(true);
    } else {
      if (!errorEstate && !errorFecha) {
        confirmDialog(
          detalle,
          estado,
          startDate.getTime(),
          startDate.toLocaleTimeString(),
          message
        );
      }
    }
  }

  async function depurarUsuarios(event) {
    event.preventDefault();
    if (detalle === "") {
      setErrorEstate(true);
    } else {
      if (!errorEstate && !errorFecha) {
        confirmDialog2(
          detalle,
          estado,
          startDate.getTime(),
          startDate.toLocaleTimeString(),
          message
        );
      }
    }
  }

  function setFechas() {
    const hoy = new Date();
    setStartDate(hoy);
    document.getElementById("resgistroHr").value = hoy.getHours();
    document.getElementById("resgistroMin").value = hoy.getMinutes();
    document.getElementById("resgistroSeg").value = hoy.getSeconds();
    if (ultimoEstado.fechaMilisec >= hoy.getTime()) {
      setErrorFecha(true);
    } else {
      setErrorFecha(false);
    }
  }
  function setFechasPick(date) {
    if (ultimoEstado.fechaMilisec >= date) {
      setStartDate(date);
      setErrorFecha(true);
    } else {
      setStartDate(date);
      setErrorFecha(false);
    }
  }

  async function getData() {
    await app
      .firestore()
      .collection("sensor")
      .orderBy("hora", "desc")
      .limit(1)
      .onSnapshot((snap) => {
        var docs = {};
        snap.forEach((doc) => {
          const diaNombre = new Date(parseInt(doc.data().hora)).getDay();
          docs = {
            fechaMilisec: doc.data().hora,
            estado: doc.data().estado,
            detalle: doc.data().detalle,
            mes: new Date(parseInt(doc.data().hora)).getMonth() + 1,
            date: new Date(parseInt(doc.data().hora)).getDate(),
            dia: new Date(parseInt(doc.data().hora)).toLocaleDateString(),
            diaNombre:
              diaNombre === 1
                ? "Lunes"
                : diaNombre === 2
                  ? "Martes"
                  : diaNombre === 3
                    ? "Miercoles"
                    : diaNombre === 4
                      ? "Jueves"
                      : diaNombre === 5
                        ? "Viernes"
                        : diaNombre === 6
                          ? "Sábado"
                          : "Domingo",
            hora: new Date(parseInt(doc.data().hora)).getHours(),
            minutos: new Date(parseInt(doc.data().hora)).getMinutes(),
          };
        });
        setUltimoEstado(docs);
      });
  }

  async function getDuplicatedUsers() {
    try {
      setLoading(true);
      app.firestore()
        .collection("users")
        .orderBy("nroDoc", "asc") // Ordenar por nroDoc ayuda
        .onSnapshot((snap) => {

          const allUsers = [];
          snap.forEach((doc) => {
            allUsers.push({ id: doc.id, ...doc.data() });
          });

          // 1️⃣ Agrupar por nroDoc
          const groupByDni = allUsers.reduce((acc, user) => {
            const dni = user.nroDoc;
            if (!acc[dni]) acc[dni] = [];
            acc[dni].push(user);
            return acc;
          }, {});

          // 2️⃣ Filtrar solo DNIs que aparecen más de una vez
          const duplicated = Object.values(groupByDni)
            .filter(group => group.length > 1) // Duplicados
            .flat(); // Opcional: si quieres 1 lista plana
          setUsers(duplicated);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
    getDuplicatedUsers();
  }, []);

  const db = (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0 text-dark">
                {" "}
                {/*Top Navigation*/} <small></small>
              </h1>
            </div>
            {/* /.col */}
            {/* /.col */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container-fluid */}
      </div>

      <div className="content">
        <div className="container">
          <div className="card card-info">
            <div className="card-header">
              <h3 className="card-title">Agregar Registro de Estado</h3>
            </div>
            <div className="card-body">
              <div className="form-group">
                <label className="ml-3">Última Actualización</label>
                {ultimoEstado ? (
                  <div
                    className="alert alert-warning mx-3"
                    style={{
                      backgroundColor:
                        ultimoEstado.estado === 5
                          ? "rgba(255,0,0,0.9)"
                          : ultimoEstado.estado === 4
                            ? "rgba(255,165,0,0.9)"
                            : ultimoEstado.estado === 3
                              ? "rgba(255,255,0,0.9)"
                              : ultimoEstado.estado === 2
                                ? "rgba(0,187,45,0.9)"
                                : "rgba(128,128,128,0.9)",
                    }}
                  >
                    <h5>
                      <i className="icon fas fa-exclamation-triangle" />{" "}
                      {ultimoEstado.detalle}
                    </h5>
                    {ultimoEstado.diaNombre + "  " + ultimoEstado.date}, a las{" "}
                    {ultimoEstado.hora}:{ultimoEstado.minutos}hrs.
                  </div>
                ) : (
                  <div>Cargando...</div>
                )}
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-4 ml-3">
                  <div className="card">
                    <div
                      className="card-body"
                      style={{ backgroundColor: "rgba(255,255,0,0.1)" }}
                    >
                      <label>Estado que se Registrará:</label>
                      <div className="input-group row ml-2">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="fas fa-bolt" />
                          </span>
                        </div>
                        <div className="col-sm-7">
                          <input
                            style={{ textAlign: "center" }}
                            className="form-control"
                            value={detalle.toUpperCase()}
                            placeholder="estado..."
                            disabled
                            type="text"
                          />
                        </div>
                      </div>
                      <br></br>
                      <label>Fecha/Hora que se Registrará:</label>
                      <div className="input-group row ml-2">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="far fa-calendar-alt" />
                          </span>
                        </div>
                        <div className="col-sm-7">
                          <input
                            style={{ textAlign: "center" }}
                            className="form-control"
                            value={
                              startDate.getDate() +
                              " / " +
                              parseInt(startDate.getMonth() + 1) +
                              " / " +
                              startDate.getFullYear()
                            }
                            disabled
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="input-group row mt-2 ml-2">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="far fa-clock" />
                          </span>
                        </div>
                        <div className="col-sm-3">
                          <input
                            id="resgistroHr"
                            style={{ textAlign: "center" }}
                            className="form-control"
                            value={startDate.getHours()}
                            disabled
                            type="text"
                          />
                        </div>
                        <h4>:</h4>
                        <div className="col-sm-3">
                          <input
                            id="resgistroMin"
                            style={{ textAlign: "center" }}
                            className="form-control"
                            value={startDate.getMinutes()}
                            disabled
                            type="text"
                          />
                        </div>
                        <h4>:</h4>
                        <div className="col-sm-3">
                          <input
                            id="resgistroSeg"
                            style={{ textAlign: "center" }}
                            className="form-control"
                            value={startDate.getSeconds()}
                            disabled
                            type="text"
                          />
                        </div>
                      </div>
                      {/* /.input group */}
                    </div>
                  </div>
                </div>

                <div className="col-sm-7 ml-3">
                  <div className="row">
                    <div className="col-sm-5 pl-4">
                      {/* radio */}
                      <label>Seleccione el Estado</label>
                      {ultimoEstado ? (
                        <div className="form-group ml-2">
                          <div className="custom-control custom-radio">
                            <input
                              className="custom-control-input custom-control-input-danger"
                              type="radio"
                              id="customRadio1"
                              name="detalle"
                              value="Falla"
                              disabled={ultimoEstado.estado === 1}
                              onChange={(e) => {
                                setDetalle(e.currentTarget.value);
                                setMessage("FALLO EN LOS SENSORES.");
                                setEstado(1);
                                setErrorEstate(false);
                              }}
                            />
                            <label
                              htmlFor="customRadio1"
                              className="custom-control-label"
                            >
                              Falla
                            </label>
                          </div>
                          <div className="custom-control custom-radio">
                            <input
                              className="custom-control-input custom-control-input-danger"
                              type="radio"
                              id="customRadio2"
                              name="detalle"
                              value="No Relámpago Detectado."
                              disabled={ultimoEstado.estado === 2}
                              onChange={(e) => {
                                setDetalle(e.currentTarget.value);
                                setMessage("NO HAY PRESENCIA DE TORMENTA ELECTRICA.");
                                setEstado(2);
                                setErrorEstate(false);
                              }}
                            />
                            <label
                              htmlFor="customRadio2"
                              className="custom-control-label"
                            >
                              No Relámpago Detectado.
                            </label>
                          </div>
                          <div className="custom-control custom-radio">
                            <input
                              className="custom-control-input custom-control-input-danger"
                              type="radio"
                              id="customRadio3"
                              name="detalle"
                              value="Precaución"
                              disabled={ultimoEstado.estado === 3}
                              onChange={(e) => {
                                setDetalle(e.currentTarget.value);
                                setMessage("Presencia de tormenta eléctrica lejana, sin riesgo. Puedes seguir trabajando con normalidad, pero atento a un cambio de alerta a color NARANJA.");
                                setEstado(3);
                                setErrorEstate(false);
                              }}
                            />
                            <label
                              htmlFor="customRadio3"
                              className="custom-control-label"
                            >
                              Precaución
                            </label>
                          </div>
                          <div className="custom-control custom-radio">
                            <input
                              className="custom-control-input custom-control-input-danger"
                              type="radio"
                              id="customRadio4"
                              name="detalle"
                              value="Aviso"
                              disabled={ultimoEstado.estado === 4}
                              onChange={(e) => {
                                setDetalle(e.currentTarget.value);
                                setMessage("Presencia de tormenta eléctrica cercana al lugar de trabajo. Debes dejar de trabajar y evacuar de forma ordenada a los refugios fijos o temporales. Si estás en un refugio no debes salir del mismo para dirigirte a otro.");
                                setEstado(4);
                                setErrorEstate(false);
                              }}
                            />
                            <label
                              htmlFor="customRadio4"
                              className="custom-control-label"
                            >
                              Aviso
                            </label>
                          </div>
                          <div className="custom-control custom-radio">
                            <input
                              className="custom-control-input custom-control-input-danger"
                              type="radio"
                              id="customRadio5"
                              name="detalle"
                              value="Alarma"
                              disabled={ultimoEstado.estado === 5}
                              onChange={(e) => {
                                setDetalle(e.currentTarget.value);
                                setMessage("La tormenta eléctrica está sobre el lugar de trabajo, no salir del refugio fijo o temporal. Si estás en un vehículo cierra las puertas y ventanas. Las garitas cerrarán el ingreso y salida hasta que culmine la alerta.");
                                setEstado(5);
                                setErrorEstate(false);
                              }}
                            />
                            <label
                              htmlFor="customRadio5"
                              className="custom-control-label"
                            >
                              Alarma
                            </label>
                          </div>
                        </div>
                      ) : (
                        <div>Cargando...</div>
                      )}
                      {errorEstate ? (
                        <h6 className="text-danger col-md-9 mt-4 ml-3">
                          *Seleccione un estado
                        </h6>
                      ) : null}
                    </div>
                    <div className="col-sm-7">
                      <div className="form-group">
                        <label>Seleccione Fecha/Hora de Registro:</label>
                        <div
                          className="input-group date ml-2"
                          id="reservationdate"
                          data-target-input="nearest"
                        >
                          <Calendar
                            id='desde'
                            value={startDate}
                            onChange={(e) => setFechasPick(e.value)}
                            monthNavigator
                            yearNavigator
                            yearRange='2020:2040'
                            dateFormat='dd/mm/yy'
                            showIcon
                            locale='es'
                            readOnlyInput
                            maxDate={new Date()}
                            style={{ width: '100%' }}
                          />
                          {/* <div
                            className="input-group-append"
                            data-target="#reservationdate"
                            data-toggle="datetimepicker"
                          >
                            <div className="input-group-text">
                              <i className="fa fa-calendar" />
                            </div>
                          </div> */}
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="form-group">
                          <label>Establecer Fecha:</label>
                          <div className="input-group row">
                            <Popup
                              trigger={
                                <button
                                  onClick={() => setFechas()}
                                  className="btn btn-primary btn-sm ml-3"
                                >
                                  <i className="fas fa-clock mr-2"></i>
                                  Fecha Actual
                                </button>
                              }
                              position="right  center"
                              on={["hover", "focus"]}
                              arrow="center center"
                            >
                              <span className="ml-10">
                                Establece los campos del nuevo registro a la
                                fecha actual.
                              </span>
                            </Popup>
                          </div>
                          {errorFecha ? (
                            <h6 className="text-danger col-md-9 mt-4 ml-3">
                              *Establezca una fecha superior a la del último
                              estado.
                            </h6>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  onClick={(e) => agregarRegistro(e)}
                  className="btn btn-info col-sm col-md-2 mt-4 ml-4"
                >
                  <i className="fas fa-database mr-2"></i>
                  Agregar Registro
                </button>
                <h6 className="text-danger col-md-9 mt-4 ml-3">
                  *Recuerde que esta acción agregará un registro en la BD y
                  cambiará el estado actual. Usar con precaución.
                  <br></br>*Esto alertará con una notificación a todos los
                  usuarios conectados.
                </h6>
              </div>
            </div>
          </div>
          <div className="card card-info">
            <div className="card-header">
              <h3 className="card-title">Registros Duplicados (DNI)</h3>
            </div>
            <div className="card-body">

              <div className="row">
                <Table
                  dataSource={users}
                  columns={columns}
                  loading={loading}
                  bordered
                  scroll={{ x: "max-content", y: 500 }}
                  rowClassName={(_, index) => {
                    if (index % 2 === 0) {
                      return "";
                    } else {
                      return "";
                    }
                  }}
                  rowKey={(record) => record.idUserAuth}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  return db;
}

export default DataBase;
